module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "添加海报"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "addPosterForm",
    staticClass: "form",
    attrs: {
      "rules": _vm.shareRules,
      "model": _vm.addPosterparams
    }
  }, [_c('Row', [_c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "海报名称：",
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入活动名称用于列表展示"
    },
    model: {
      value: (_vm.addPosterparams.name),
      callback: function($$v) {
        _vm.$set(_vm.addPosterparams, "name", $$v)
      },
      expression: "addPosterparams.name"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "海报分类：",
      "prop": "sharePosterType"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.addPosterparams.sharePosterType),
      callback: function($$v) {
        _vm.$set(_vm.addPosterparams, "sharePosterType", $$v)
      },
      expression: "addPosterparams.sharePosterType"
    }
  }, _vm._l((_vm.$constant.sharePosterType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "活动归属：",
      "prop": "activityId"
    }
  }, [_c('activity-select', {
    attrs: {
      "label": _vm.name
    },
    model: {
      value: (_vm.addPosterparams.activityId),
      callback: function($$v) {
        _vm.$set(_vm.addPosterparams, "activityId", $$v)
      },
      expression: "addPosterparams.activityId"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "配套海报：",
      "prop": "url"
    }
  }, [_c('image-upload-New', {
    attrs: {
      "defaultFileList": _vm.defaultPicList
    },
    model: {
      value: (_vm.addPosterparams.url),
      callback: function($$v) {
        _vm.$set(_vm.addPosterparams, "url", $$v)
      },
      expression: "addPosterparams.url"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "海报排序：",
      "prop": "sort"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 0,
      "max": 100000
    },
    model: {
      value: (_vm.addPosterparams.sort),
      callback: function($$v) {
        _vm.$set(_vm.addPosterparams, "sort", $$v)
      },
      expression: "addPosterparams.sort"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "海报状态：",
      "prop": "status"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.addPosterparams.status),
      callback: function($$v) {
        _vm.$set(_vm.addPosterparams, "status", $$v)
      },
      expression: "addPosterparams.status"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "0"
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("启用")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAddPoster
    },
    on: {
      "click": _vm.createPoster
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-377b5d4c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/market/modal/CreateShareModal.vue
// module id = 1754
// module chunks = 8